/**
 * Lien de partage WhatsApp (`wa.me`) — pur.
 *
 * `wa.me` exige le numéro INTERNATIONAL, chiffres seuls, sans « + » ni « 00 ».
 * Un numéro malien local à 8 chiffres ne marcherait pas : on ne devine pas
 * l'indicatif par défaut, sauf si l'appelant le demande (`indicatifParDefaut`).
 */
const LONGUEUR_MIN = 10
const LONGUEUR_MAX = 15 // E.164

export function chiffresTelephone(telephone: string | null | undefined, indicatifParDefaut?: string): string | null {
  let n = String(telephone ?? '').replace(/\D/g, '')
  if (n.startsWith('00')) n = n.slice(2)
  if (indicatifParDefaut && n.length === 8) n = indicatifParDefaut.replace(/\D/g, '') + n
  return n.length >= LONGUEUR_MIN && n.length <= LONGUEUR_MAX ? n : null
}

/** `https://wa.me/<numéro>?text=<message + lien>`, ou `null` si le numéro est invalide. */
export function lienWhatsApp(
  telephone: string | null | undefined,
  message: string,
  lien: string,
  indicatifParDefaut?: string,
): string | null {
  const numero = chiffresTelephone(telephone, indicatifParDefaut)
  if (!numero) return null
  const texte = [message.trim(), lien.trim()].filter(Boolean).join('\n')
  return `https://wa.me/${numero}?text=${encodeURIComponent(texte)}`
}
